<template>
  <div
    class="footer"
    :style="{
      background: color,
    }"
  >
    <div class="about">
      <p class="white">
        <router-link to="/introduce/index" class="white">{{
          $t("aboutOur")
        }}</router-link
        >|
        <a
          href="https://www.facebook.com/YoFi-Games-106802404610515"
          target="_blank"
          class="white"
          >{{ $t("careOur") }}</a
        >
      </p>
      <p class="grey">
        © {{ $t("address") }} {{ $t("company") }} |
        <a
          :href="
            baseUrl + '/sdk/api/gw/web/userAgreement.html?language=' + language
          "
          target="_blank"
          class="grey"
          >{{ $t("agreement") }}</a
        >|
        <a
          :href="
            baseUrl + '/sdk/api/gw/web/privacyPolicy.html?language=' + language
          "
          target="_blank"
          class="grey"
          >{{ $t("privacy") }}</a
        >
      </p>
    </div>
  </div>
</template>
<script>
export default {
  props: ["color"],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      language: localStorage.getItem("locale"),
    };
  },
};
</script>

<style lang="scss" scoped>
.footer {
  font-size: 16px;
  text-align: center;
  padding-bottom: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: #333333;
  height: 80px;
  .logo {
    img {
      width: 120px;
    }
  }
  .about {
    color: #ffffff;
    .white {
      line-height: 30px;
      margin-right: 6px;
      color: #ffffff;
    }
    .grey {
      line-height: 30px;
      color: #ffffff;
      margin-right: 6px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/page/footer.vue